
import "./InvalidCoupon.scss";
import Emoiji from "../../common/assets/png/greatchoiceemoji.png"
import { useSelector } from "react-redux";


const InvalidCoupon = ({ open, onClose }:any) => {
        const isMobile = useSelector((state: any) => state?.navigation?.isMobile)

  if (!open) return null;


  return (
    <div className="Invalid-coupon-overlay">
      <div className="Invalid-coupon-popup">
        {/* Close Button */}
        {
            isMobile && 
             <button className="Inavlid-coupon-close-btn" onClick={onClose}>
          ✕
        </button>
        }
       
        {/* Content */}
        <h2 className="Inavlid-coupon-text">Coupon Invalid</h2>

        <p className="Inavlid-coupon-container">
         The coupon code is no longer valid or used already. Please try a valid coupon code.
         
        </p>

        {/* CTA */}
        <button className="gotit-btn" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>
  );
};

export default InvalidCoupon;
